import { render, staticRenderFns } from "./ProductTypes.vue?vue&type=template&id=8a397130"
import script from "./ProductTypes.vue?vue&type=script&lang=js"
export * from "./ProductTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports